import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    margin: 0 16px;
  }
`;

export const HeroPageSubheading = styled.div`
  color: #747679;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 8px 0;

  @media (max-width: 800px) {
    color: #ffffff;
    margin: 12px 0;
  }
`;

export const LogoImage = styled.img`
  @media (max-width: 800px) {
    max-width: 90%;
  }
`;

export const MemberLink = styled.button`
  align-items: center;
  background: #1e1f20;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  justify-content: center;
  line-height: 24px;
  margin-top: 24px;
  padding: 12px 0;
  text-align: center;
  text-decoration: none;
  width: 100%;

  @media (max-width: 800px) {
    background: #ffffff;
    color: #1e1f20;
    padding: 12px 32px;
    width: auto;
  }
`;
